import { useId, useMemo, type HTMLAttributes } from 'react';
import { scopeSvg } from './svg';

/** Repository-owned SVG files only; keeps CSS paints and namespaces repeated fragment IDs. */
export function SvgArtwork({
  svg,
  ...props
}: { svg: string } & Omit<
  HTMLAttributes<HTMLSpanElement>,
  'children' | 'dangerouslySetInnerHTML'
>) {
  const id = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const markup = useMemo(() => scopeSvg(svg, id), [svg, id]);
  return <span {...props} aria-hidden="true" dangerouslySetInnerHTML={{ __html: markup }} />;
}
